/**
 * Sticky Elements
 *
 */
(function($) {


    $(window).on('load', initSticky);

    var resizeTimeout;
    $(window).resize(function() {
        if (resizeTimeout) clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(initSticky, 1000);
    });

    function initSticky(){
        var $body = $('body:eq(0)');

        $(document).unbind('scroll.sticky');

        var stickyTop;

        var $stickyWidgets = $('.widget-sticky');
        if ($stickyWidgets.length) {

            var $stickyFirst = $stickyWidgets.eq(0);
            var $stickySecond = $stickyWidgets.eq(1);

            /**
             *  Sticky top
             */
            if ($stickyFirst.length) {
                $stickyFirst.addClass('sticky-first');
                $stickyFirst.removeClass('fixed');
                $body.removeClass('sticky-one');

                if (!$stickyFirst.data('offset-top') || !$stickyFirst.data('outer-height')) {
                    var hiddenElm = false;
                    if ($stickyFirst.is(':hidden')) {
                        $stickyFirst.css({'display': 'block', 'visibility': 'hidden'});
                        hiddenElm = true;
                    }

                    $stickyFirst.data('offset-top', $stickyFirst.offset().top);
                    $stickyFirst.data('outer-height', $stickyFirst.outerHeight());

                    if (hiddenElm) {
                        $stickyFirst.css({'display': 'none', 'visibility': 'visible'});
                    }
                }

                var stickyQuery = function(){
                    var belowThreshold = $(window).scrollTop() >= $stickyFirst.data('offset-top');
                    var isFixed = $stickyFirst.hasClass('fixed');

                    if (!isFixed && belowThreshold) {
                        $stickyFirst.addClass('fixed');
                        $body.addClass('sticky-one');
                        stickyTop = $stickyFirst.outerHeight();
                    } else if (isFixed && !belowThreshold) {
                        $stickyFirst.removeClass('fixed');
                        $body.removeClass('sticky-one');
                        stickyTop = 0;
                    }
                };

                stickyQuery();

                $(document).on('scroll.sticky', stickyQuery);
            };

            /**
             *  Sticky second
             */
            if ($stickySecond.length) {
                $stickySecond.addClass('sticky-second');
                $stickySecond.removeClass('fixed');
                $body.removeClass('sticky-two');

                $stickySecond.data('offset-top', $stickySecond.offset().top);
                $stickySecond.data('outer-height', $stickySecond.outerHeight());

                if (matchMedia('only screen and (max-width: 767px)').matches) {
                    $stickySecond.removeClass('fixed');
                    $body.removeClass('sticky-two');
                } else {
                    var stickyQuery = function(){
                        var belowThreshold = ($(window).scrollTop() + stickyTop) >= $stickySecond.data('offset-top');
                        var isFixed = $stickySecond.hasClass('fixed');
                        var isSticky = $stickySecond.is(':visible') && $stickySecond.data('outer-height') < $(window).height();

                        if (!isFixed && belowThreshold && isSticky) {
                            $stickySecond.addClass('fixed');
                            $body.addClass('sticky-two');
                        } else if (isFixed && !belowThreshold) {
                            $stickySecond.removeClass('fixed');
                            $body.removeClass('sticky-two');
                        }
                    };

                    stickyQuery();

                    $(document).on('scroll.sticky', stickyQuery);
                }
            }
        }

        /**
         *  Sticky bottom
         */
        var $stickyWidgets = $('.widget-sticky-bottom');
        if ($stickyWidgets.length) {
            var $stickyBottom = $stickyWidgets.eq(0);

            if ($stickyBottom.length) {
                $stickyBottom.removeClass('fixed');
                $body.removeClass('bottom-fixed');

                $stickyBottom.data('outer-height', $stickyBottom.outerHeight());
                $stickyBottom.data('offset-bottom', $stickyBottom.offset().top + $stickyBottom.data('outer-height'));

                if (matchMedia('only screen and (max-height: 812px)').matches) {
                    $stickyBottom.removeClass('fixed');
                    $body.removeClass('bottom-fixed');
                } else {
                    var stickyQuery = function () {
                        var aboveThreshold = ($(window).height() + $(window).scrollTop()) <= $stickyBottom.data('offset-bottom');
                        var isFixed = $stickyBottom.hasClass('fixed');
                        var isSticky = $stickyBottom.is(':visible') && $stickyBottom.data('outer-height') < $(window).height();

                        if (!isFixed && aboveThreshold && isSticky) {
                            $stickyBottom.addClass('fixed');
                            $body.addClass('bottom-fixed');
                        } else if (isFixed && !aboveThreshold) {
                            $stickyBottom.removeClass('fixed');
                            $body.removeClass('bottom-fixed');
                        }
                    };

                    stickyQuery();

                    $(document).on('scroll.sticky', stickyQuery);
                }
            }
        }
    };


})(jQuery);
